const stickyThreshold = 100; // px

$(window).on("scroll", function () {
    if ($(this).scrollTop() > stickyThreshold) {
        $("header").addClass("sticky");
    } else {
        $("header").removeClass("sticky");
    }
});
